import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const beveragesIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  water: (props) => (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m22 21.6072a11.9193 11.9193 0 0 1 1.7386-6.1072 14.87 14.87 0 0 1 3.2857-3.8679 4.0617 4.0617 0 0 0 1.4757-3.1321h7a4.0617 4.0617 0 0 0 1.4757 3.1321 14.87 14.87 0 0 1 3.2857 3.8679 11.9193 11.9193 0 0 1 1.7386 6.1072v21.4786a3.4142 3.4142 0 0 1 -1 2.4142 3.4142 3.4142 0 0 1 1 2.4142v9.0858c0 1.3807-1.4924 2.5-3.3333 2.5a3.62 3.62 0 0 1 -2.9217-1.2956.5013.5013 0 0 0 -.8234 0 3.9419 3.9419 0 0 1 -5.8432 0 .5013.5013 0 0 0 -.8234 0 3.62 3.62 0 0 1 -2.9217 1.2956c-1.8409 0-3.3333-1.1193-3.3333-2.5v-9.0858a3.4142 3.4142 0 0 1 1-2.4142 3.4142 3.4142 0 0 1 -1-2.4142z"
        fill="#a3dfee"
      ></path>
      <path
        d="m40 57v-9.0858a3.8888 3.8888 0 0 0 -.8-2.4142 3.8888 3.8888 0 0 0 .8-2.4142v-21.4786a14.2106 14.2106 0 0 0 -1.3909-6.1072 14.5307 14.5307 0 0 0 -2.6285-3.8679 4.524 4.524 0 0 1 -1.1806-3.1321h.7a4.0617 4.0617 0 0 0 1.4757 3.1321 14.87 14.87 0 0 1 3.2857 3.8679 11.9193 11.9193 0 0 1 1.7386 6.1072v21.4786a3.4142 3.4142 0 0 1 -1 2.4142 3.4142 3.4142 0 0 1 1 2.4142v9.0858c0 1.3807-1.4924 2.5-3.3333 2.5a4.4114 4.4114 0 0 1 -.74-.0629 2.5418 2.5418 0 0 0 2.0733-2.4371z"
        fill="#88cedc"
      ></path>
      <path
        d="m37.5 57v-9.0858a5.14 5.14 0 0 0 -.55-2.4142 5.14 5.14 0 0 0 .55-2.4142v-21.4786a19.7331 19.7331 0 0 0 -.9563-6.1072 16.0253 16.0253 0 0 0 -1.8071-3.8679 5.8272 5.8272 0 0 1 -.8116-3.1321h.875a4.524 4.524 0 0 0 1.1806 3.1321 14.5307 14.5307 0 0 1 2.6285 3.8679 14.2106 14.2106 0 0 1 1.3909 6.1072v21.4786a3.8888 3.8888 0 0 1 -.8 2.4142 3.8888 3.8888 0 0 1 .8 2.4142v9.0858a2.5418 2.5418 0 0 1 -2.0733 2.4371 3.9338 3.9338 0 0 1 -1.1949-.4029 2.8551 2.8551 0 0 0 .7682-2.0342z"
        fill="#94daeb"
      ></path>
      <path
        d="m24 21.6072a14.2106 14.2106 0 0 1 1.3909-6.1072 14.5307 14.5307 0 0 1 2.6285-3.8679 4.524 4.524 0 0 0 1.1806-3.1321h.875a5.8272 5.8272 0 0 1 -.8116 3.1321 16.0253 16.0253 0 0 0 -1.8071 3.8679 19.7331 19.7331 0 0 0 -.9563 6.1072v21.4786a5.14 5.14 0 0 0 .55 2.4142 5.14 5.14 0 0 0 -.55 2.4142v9.0858a2.8551 2.8551 0 0 0 .7682 2.0342 3.9338 3.9338 0 0 1 -1.1949.4029 2.5418 2.5418 0 0 1 -2.0733-2.4371v-9.0858a3.8888 3.8888 0 0 1 .8-2.4142 3.8888 3.8888 0 0 1 -.8-2.4142z"
        fill="#bde8f2"
      ></path>
      <path d="m22 21.5h20v20h-20z" fill="#4e88e8"></path>
      <path
        d="m40 21.6072c0-.0359-.0013-.0714-.0016-.1072h2c0 .0358.002.0713.002.1072v19.8928h-2.0004z"
        fill="#4173da"
      ></path>
      <path
        d="m39.9984 21.5c0 .0358.0016.0713.0016.1072v19.8928h-2.5v-19.8928c0-.0359-.0009-.0714-.0011-.1072z"
        fill="#477de0"
      ></path>
      <path
        d="m26.5 21.6072v19.8928h-2.5v-19.8928c0-.0359.0013-.0714.0016-.1072h2.5c-.0007.0358-.0016.0713-.0016.1072z"
        fill="#6799eb"
      ></path>
      <path
        d="m28.5 8.5h7a.5.5 0 0 0 .5-.5v-2.5a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v2.5a.5.5 0 0 0 .5.5z"
        fill="#4e88e8"
      ></path>
      <path
        d="m34.134 4.5h.866a1 1 0 0 1 1 1v2.5a.5.5 0 0 1 -.5.5h-.5v-3.134a.866.866 0 0 0 -.866-.866z"
        fill="#4173da"
      ></path>
      <path
        d="m33.2929 4.5h.8411a.866.866 0 0 1 .866.866v3.134h-1v-3.2929a.7071.7071 0 0 0 -.7071-.7071z"
        fill="#477de0"
      ></path>
      <path
        d="m29.866 4.5h.8411a.7071.7071 0 0 0 -.7071.7071v3.2929h-1v-3.134a.866.866 0 0 1 .866-.866z"
        fill="#6799eb"
      ></path>
      <rect fill="#caecf4" height=".8" rx=".4" width="8.5" x="27.75" y="9.3"></rect>
    </svg>
  ),
  soda: (props) => (
    <svg viewBox="0 0 53 53" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="_x34_1">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g fill="#febc1f">
                      <path d="m18.8154659 49.1760788c2.0407715.7623291 4.3395386 1.2037964 6.6625366 1.3005371-2.3384399-.0924072-4.6226806-.5338745-6.6625366-1.3005371z"></path>
                      <path d="m18.3080196 48.9966354c.1635132.0673828.3403931.1166382.5074463.1794434-.0661335-.0247307-.2699947-.0844917-.5074463-.1794434z"></path>
                      <path d="m34.0979958 49.2166061c-1.8950577.775589-5.1741982 1.4120255-8.6199932 1.2600098 2.8563709.115078 5.8323364-.245964 8.6199932-1.2600098z"></path>
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d="m40.7779884 15.466608c-.0002365.1014481-.0356064 27.0072346-.2599487 27.9799786-1.6674347 7.2187767-16.6384296 9.0071411-24.0700054 4.6500244 0-.0100098-.0100098-.0100098-.0100098-.0100098-1.7025423-1.0403442-3.1564379-2.2296333-3.8800058-4.0899658 0-.0200195-.0100098-.0400391-.0200195-.0500488-.3947191-1.0527763-.2015476-28.4465256-.2000122-28.5499859 0 .1000366 0 .1900024.0100098.2900391.0432949-.142622-.4969883-3.4035549 4.1199961-6.0800171 5.5400391-3.2100224 14.5500488-3.2100224 20.1100445 0 2.8099974 1.6199951 4.199951 3.7399902 4.199951 5.8599853z"
                        fill="#febc1f"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d="m40.781002 15.4798155-.126461 26.8241463c0 7.466671-15.4708195 10.8354912-24.2107296 5.7933121-2.8081026-1.6444664-4.2248144-3.744133-4.2248144-5.8692818l.126462-26.8239937c0-2.099823 1.366066-4.199645 4.1236763-5.7934666 5.5403881-3.2128105 14.5466652-3.2128105 20.1123772 0 2.8081016 1.6191464 4.1994895 3.7442923 4.1994895 5.8692837z"
                        fill="#ffd06c"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d="m40.7758484 15.4679155c-.0012169.2818966-.1142273 26.4133072-.1147919 26.8398209 0 2.6725121-2.2718658 4.8751869-4.6627808 6.0710487-6.3292732 3.4142113-16.8889523 2.5665054-21.4885368-1.6794319-1.5229988-1.35606-2.2844658-2.9207611-2.2844658-4.4854622.1572256-36.7528801.1029978-24.076767.1147289-26.8190002 0 3.079854 2.9469709 5.5312204 5.8102646 6.6447592 7.1048775 3.0658226 18.4715023 1.7296829 21.8223476-3.8596096.4915048-.7693482.8032342-1.745596.8032342-2.7121249z"
                        fill="#febc1f"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
              <path
                d="m35.4871521 37.0503616c-.5111275 6.7177887 2.9207611 8.0112648 4.1829758 8.2616043-.8691177 1.3035507-2.2998581 2.3805885-3.6718521 3.0668182-5.9875793-6.4256783-.1251717-24.5553532-.1251717-24.5553532.2510223-.9357529.3168449-1.8497906.2399025-2.6182766-.2294579-2.2635841-1.6064034-3.2650166-1.6064034-3.2650166l3.7761383-2.545249c1.2041016.608264 1.6250801 2.5673018 1.721199 3.9117537v.0625839c-2.9208259 6.1857778-4.5167884 17.6811353-4.5167884 17.6811353z"
                fill="#fff"
                opacity=".2"
              ></path>
              <path
                d="m18.6092491 49.1089897c-1.427021-.5400162-2.982234-1.3782654-4.0995102-2.4096375 1.2725935-.2607803 4.6836624-1.5647011 4.1725368-8.2616653 0 0-1.5960255-11.4952965-4.5167885-17.6810741.0887194-1.3759022.4975367-3.3559952 1.7211323-3.9743385l4.0369873 2.1175308c-.0410976.1149406-2.7474747 2.1751881-1.627285 6.3109474.0000001 0 5.580742 18.0984173.3129273 23.8982372z"
                fill="#fff"
                opacity=".2"
              ></path>
              <g>
                <g>
                  <path
                    d="m39.4371567 10.0357656-.0121078 2.4625969c-.0189056 6.6745176-13.9838963 9.9049978-22.0407295 5.2533827-2.5470333-1.4705296-3.8191233-3.4034472-3.813652-5.333396l.0120878-2.4625778c-.0054588 1.9299393 1.2666321 3.8628578 3.8136644 5.3333874 8.0072269 4.6229754 22.0217971 1.4268885 22.0407371-5.2533932z"
                    fill="#c9cee2"
                  ></path>
                </g>
              </g>
              <g>
                <path
                  d="m35.6176529 4.7001352c5.0615005 2.9222589 5.1015167 7.6627731.0662689 10.5889397-5.0286045 2.9223051-13.2260017 2.9223433-18.2875023.0000839s-5.0882254-7.6704955-.0596218-10.5928001c5.0352497-2.9261675 13.2193546-2.9184822 18.2808552.0037765z"
                  fill="#e3e7f0"
                ></path>
              </g>
              <g>
                <path
                  d="m39.4402618 10.0405664-.0253258 2.4540396c0 6.7121105-14.0053368 9.8791027-22.0350914 5.2621403-2.5551777-1.4673576-3.8201056-3.4153957-3.8201056-5.33811l.0253239-2.453886c0-6.6718717 13.9585047-9.9464531 22.0350914-5.2621412 2.5551768 1.467359 3.8452769 3.4153967 3.8201075 5.3379573z"
                  fill="#c9cee2"
                ></path>
              </g>
              <g>
                <g>
                  <path
                    d="m39.4371567 10.0357656-.0121078 2.4625969c-.0189056 6.6745176-13.9838963 9.9049978-22.0407295 5.2533827-2.5470333-1.4705296-3.8191233-3.4034472-3.813652-5.333396l.0120878-2.4625778c-.0054588 1.9299393 1.2666321 3.8628578 3.8136644 5.3333874 8.0072269 4.6229754 22.0217971 1.4268885 22.0407371-5.2533932z"
                    fill="#c9cee2"
                  ></path>
                </g>
              </g>
              <g>
                <path
                  d="m35.6176529 4.7001352c5.0615005 2.9222589 5.1015167 7.6627731.0662689 10.5889397-5.0286045 2.9223051-13.2260017 2.9223433-18.2875023.0000839s-5.0882254-7.6704955-.0596218-10.5928001c5.0352497-2.9261675 13.2193546-2.9184822 18.2808552.0037765z"
                  fill="#e3e7f0"
                ></path>
              </g>
              <g>
                <path
                  d="m17.656086 6.7454004c7.1308422-4.1440721 19.8543968-1.8615012 21.214489 4.2059231.480423-2.1546698-.7039871-4.4123502-3.569912-6.0670176-4.885334-2.8205462-12.7845726-2.8279247-17.644577-.0036025-2.8262396 1.6424088-3.9856691 3.8816133-3.5069313 6.023211.338603-1.5211553 1.4982061-2.9911832 3.5069313-4.158514z"
                  fill="#c9cee2"
                ></path>
                <path
                  d="m17.713604 15.1048412c7.1790237 4.1448059 19.8145485 1.8670006 21.156971-4.1535177-1.3538132-6.0394087-14.0398121-8.3754692-21.214489-4.2059231-2.0087252 1.1673307-3.1683283 2.6373587-3.5069313 4.158514.3434248 1.5362616 1.5238285 3.0227318 3.5644493 4.2009268z"
                  fill="#9ea9c9"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m28.2541771 12.1936264c.422657.7359934.2984619 1.4479818-.4530315 1.9066153-1.5503941.9423218-4.4957275.3230391-6.2143364-.6691999-1.9482727-1.1248369-2.4943256-2.64077-1.2138653-3.423542.7590675-.4586515 1.9800854-.5634766 3.266964-.3560085.3358765.0502329.6824036-.0109053.904026-.1616116l2.4450397-1.6870475 4.2172241 2.3998437-2.7212448 1.462409c-.2443123.1332521-.3412285.3385419-.2307758.5285415zm-6.0045719.98281c1.8116856.9980822 4.1697712 1.2754374 5.2594395.6115131 1.287096-.7843666.1210346-2.2157087-1.321537-3.0095348-1.8154602-1.0046158-4.1697617-1.2797871-5.2632141-.6180468-1.2887517.7853451-.1145478 2.2190276 1.3253116 3.0160685z"
              fill="#111d33"
            ></path>
          </g>
          <g>
            <path
              d="m32.1579933 8.6266422-2.4299908-1.4100347c-.539978-.3200073-1.4199829-.3099976-1.9599609 0-.0200195.0100098-.0400391.0200195-.0600586.0400391l-3.1299438 2.0399785c-.2400513.1499634-.3500366.3499756-.3500366.539978v.2000122c0 .5358105.6537018.6222982 2.4100342 1.7299805.5199585.3000488 1.3499756.3200073 1.8999634.0400391l3.5499859-1.8099976c.0200195-.0100098.0400391-.0200195.0599976-.0300293.2800293-.1599731.4100342-.3699951.4100342-.5800171v-.1699829c.0100096-.2099609-.1199953-.4299926-.4000246-.5899658zm-7.5299663 1.7799683c-.0700073-.039978-.1300049-.0899658-.1799927-.1400146.0499878.0500488.1099854.0900269.1799927.1300049l2.0100098 1.1799927z"
              fill="#1d2943"
            ></path>
          </g>
          <path
            d="m32.5598297 9.1890831v.2023973c0 .208498-.1349449.4170332-.4109306.5703564-.0183792.0122404-.0367966.024519-.0613174.0367966l-3.5448437 1.8030796c-.5519409.2820902-1.3860092.2698498-1.9011917-.0306568-1.6871853-1.0662889-2.4163704-1.1826572-2.4163704-1.7356272v-.1962576c0 .2023964.1349049.4047565.398653.5642176l2.0177174 1.1714096c.5151825.3005066 1.3492508.312747 1.9011917.0306568l3.5448437-1.8092194c.0245209-.0122776.0429382-.0183792.0613174-.0306568.2759857-.159462.4109306-.3679981.4109306-.5764961z"
            fill="#1d2943"
          ></path>
          <g>
            <path
              d="m27.7668285 7.2152061c-.0204735.0118203-.0405598.0241432-.0599861.036849l-3.1299591 2.0459433c-.4896603.3187551-.4689655.8025532.0484352 1.1032343l2.0151234 1.1710615c.5174007.3006802 1.3525581.314249 1.9044533.031661l3.5423279-1.8063021c.0220375-.0112343.0433235-.0227976.0638237-.0346336.5367508-.3098936.5485268-.8206749.0052071-1.1364193l-2.4274921-1.4107027c-.5433542-.3157629-1.4251272-.310616-1.9619333-.0006914z"
              fill="#4c5c75"
            ></path>
          </g>
          <g>
            <path
              d="m28.3577633 7.7950373c.1419201-.0851431.3689823-.0780406.5109024 0l2.2350788 1.298501c.0441742.0265045.0696831.0575562.0863552.0897779.0368557-.0711985.0113907-.1495857-.0863552-.2082243l-2.2350788-1.2985015c-.1419201-.0780411-.3689823-.0851436-.5109024 0l-.6669865.3831449c-.0963593.053009-.1188793.1317863-.0844498.2038069.0511494-.1001005.1301098-.0992737.7514363-.4685049z"
              fill="#1d2943"
            ></path>
            <path
              d="m26.1368465 9.2588882c-.3367195.1973972-.4851799.4577646-.4576797.7115927.0248604-.214591.1734924-.4265404.4576797-.5931454.9209023-.5292578 2.5892048-.2238588 2.6802387.5876884.0288869-.2520522-1.7062434-1.2659062-2.6802387-.7061357z"
              fill="#1d2943"
            ></path>
            <g fill="#111d33">
              <path d="m29.9258995 9.6562386c.1418762.078084.3689404.0851431.5108585 0l.6669865-.3831453c.0441742-.0265045.0696831-.0575562.0863552-.089777-.0166721-.0322218-.042181-.0632734-.0863552-.0897779l-2.2350788-1.298501c-.1419201-.0780406-.3689823-.0851431-.5109024 0l-.6669865.3831453c-.0435238.0239496-.0683403.0538321-.0844498.0853596.0578175.1211871.0289994.0415667 2.3195725 1.3926963z"></path>
              <path d="m26.1368465 9.3773355c-.2841873.166605-.4328194.3785543-.4576797.5931454.0872746.8042278 1.7522163 1.1228695 2.6785965.5798063.2863083-.1626644.4348545-.3718424.459322-.5852633-.0937558-.8358058-1.778225-1.1060905-2.6802388-.5876884z"></path>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m27.0979977 10.9366398v.0999756c-.0100098.2200317-.1499634.4400024-.4400024.6099854-.9674759.5576048-2.6025333.1320972-2.5700073-.6199951v-.0800171c-.0099487-.2299805.1300049-.4599609.4300537-.6299438 1.1827583-.6816835 3.065897.0861444 2.4599609.9400024.080017-.1000367.1199951-.2100221.1199951-.3200074z"
                  fill="#c9cee2"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m27.0935726 10.9367085-.0002861.1005869c-.0006275.2217255-.1461239.4431152-.436779.6120262-.9182434.5336246-2.5755081.1707134-2.5732632-.6206007l.0002804-.1005831c-.0022984.8158731 1.6728992 1.1438341 2.573267.6205969.290657-.168911.4361534-.3902998.4367809-.6120262z"
                  fill="#c9cee2"
                ></path>
              </g>
              <g>
                <ellipse
                  cx="25.589"
                  cy="10.932"
                  fill="#e3e7f0"
                  rx=".872"
                  ry="1.505"
                  transform="matrix(.003 -1 1 .003 14.584 36.491)"
                ></ellipse>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  tea: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m488 256v49.36a32 32 0 0 1 -21.35 30.175l-114.65 40.465v-34.86l93.381-33.348a16 16 0 0 0 10.619-15.068v-20.724a16 16 0 0 0 -16-16h-88v-32h104a32 32 0 0 1 32 32z"
        fill="#d9dbdd"
      ></path>
      <path
        d="m310.071 432h-158.071c-110.75-80-88-248-88-248h334.071s22.75 168-88 248z"
        fill="#e0e2e5"
      ></path>
      <path
        d="m399.01 248c-4.04 56.08-22.39 135.93-88.94 184h-158.07c-66.55-48.07-84.9-127.92-88.94-184z"
        fill="#f4ae40"
      ></path>
      <path d="m480 424s0 64-72 64h-304c-72 0-72-64-72-64z" fill="#d9dbdd"></path>
      <path
        d="m280 296a8 8 0 0 1 -8-8v-104a8 8 0 0 1 16 0v104a8 8 0 0 1 -8 8z"
        fill="#c46f2a"
      ></path>
      <path d="m312 312v80h-64v-80l32-32z" fill="#e07e30"></path>
      <g fill="#e0e2e5">
        <path d="m229.333 160a8 8 0 0 1 -5.656-13.657c.738-.768 19.066-20.445-1.2-54.227-14.184-23.64-10.778-42.645-5.423-54.427a55.778 55.778 0 0 1 15.48-20.089 8 8 0 0 1 9.633 12.774 40.217 40.217 0 0 0 -10.8 14.5c-5.18 11.913-3.556 25.038 4.827 39.011 26.905 44.841-.042 72.612-1.2 73.773a7.974 7.974 0 0 1 -5.661 2.342z"></path>
        <path d="m136 160a8 8 0 0 1 -5.657-13.657c1.831-1.871 17.638-19.048 0-36.686-15.287-15.288-14.383-30.836-10.932-41.187a49.74 49.74 0 0 1 10.932-18.127 8 8 0 0 1 11.343 11.285c-1.862 1.9-17.666 19.078-.029 36.715 15.287 15.288 14.383 30.836 10.932 41.187a49.74 49.74 0 0 1 -10.932 18.127 7.976 7.976 0 0 1 -5.657 2.343z"></path>
        <path d="m328 160a8 8 0 0 1 -5.657-13.657c1.831-1.871 17.637-19.048 0-36.686-15.287-15.288-14.383-30.836-10.933-41.187a49.765 49.765 0 0 1 10.933-18.127 8 8 0 0 1 11.343 11.285c-1.863 1.9-17.665 19.078-.029 36.715 15.287 15.288 14.383 30.836 10.933 41.187a49.765 49.765 0 0 1 -10.933 18.127 7.974 7.974 0 0 1 -5.657 2.343z"></path>
      </g>
    </svg>
  ),
  coffee: (props) => (
    <svg
      height="512"
      viewBox="0 0 450 450"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="m10.5 79.2c3.2-28.4 15.9-51.6 37.5-62.7.2-.1.4-.3.7-.3 21.7-10.9 47.9-7.5 72.8 6.8 24.4 14 47.5 38.6 63.7 70.5 16.2 31.9 22.3 65.1 19.3 93-3.1 28.5-15.9 51.6-37.5 62.8-.2.1-.4.3-.7.4-21.7 10.8-47.9 7.5-72.8-6.9-24.4-14-47.5-38.6-63.7-70.5-16.2-31.9-22.3-65.1-19.3-93.1z"
            fill="#805333"
          ></path>
          <path
            d="m62.2 36c.1 0 46.1 6.5 60.2 76.5 2.2 11.1 2.1 14.6 1.9 22.5 0 1.6-.1 3.5-.1 5.4-.1 7.7.8 19.6 5.4 33.7 4.6 14.2 13 30.7 27.9 47.6 1.7 1.9 1.5 4.9-.4 6.6-1.3 1.1-3.1 1.4-4.6.9-4.2-1.2-54.9-16.6-61.4-87.3l-.3-3c-3.1-33.3-6.6-71.9-32.3-94.9-1.9-1.7-2.1-4.7-.4-6.6 1-1.1 2.6-1.7 4.1-1.4z"
            fill="#5e3d25"
          ></path>
          <path
            d="m98.9 134.9c-3-33.3-6.6-71.9-32.3-94.9-1-.9-1.5-2.1-1.6-3.4-1.8-.5-2.8-.6-2.8-.6-1.5-.2-3.1.3-4.2 1.5-1.7 1.9-1.6 4.9.4 6.6 25.7 23 29.3 61.6 32.3 94.9l.3 3c6.5 70.7 57.2 86.1 61.4 87.3 1.5.5 3.3.2 4.6-.9 1.1-1 1.7-2.4 1.6-3.8-10.5-3.6-53.4-22.1-59.4-86.6z"
            fill="#4d321e"
          ></path>
          <path
            d="m107.5 230.4c-52.5-30.3-89.5-103.2-82.9-163.5 2.1-19 8.4-35.5 18.8-47.8-18.8 11.9-29.9 33.7-32.9 60.1-6.6 60.3 30.4 133.2 82.9 163.5 24.8 14.3 51 17.7 72.8 6.9.2-.1.5-.2.7-.4 7.2-3.7 13.4-8.8 18.7-14.9-1.5.9-3 1.8-4.6 2.6-.2.1-.4.3-.7.4-21.7 10.8-47.9 7.4-72.8-6.9z"
            fill="#5e3d25"
          ></path>
        </g>
        <g>
          <path
            d="m354 64.6c28.3-4.3 54 2 70.3 19.9.2.2.4.4.5.6 16.1 18.2 19.6 44.4 12.2 72.1-7.2 27.2-25 55.9-51.6 79.8-26.6 23.9-57.1 38.4-84.8 42.7-28.3 4.3-54-2-70.3-20-.2-.2-.4-.4-.5-.6-16.1-18.2-19.6-44.4-12.2-72.1 7.2-27.2 25-55.9 51.6-79.8 26.6-23.8 57-38.3 84.8-42.6z"
            fill="#805333"
          ></path>
          <path
            d="m409.2 103.3c0 .1 5.7 46.2-58.4 78-10.1 5-13.5 5.9-21.2 7.7-1.6.4-3.4.8-5.3 1.3-7.5 1.9-18.7 5.8-31.2 13.9s-26.3 20.5-38.8 39.2c-1.4 2.2-4.4 2.7-6.5 1.3-1.4-1-2.2-2.6-2.1-4.2 0-4.3 1.9-57.3 68.4-81.9l2.8-1.1c31.4-11.6 67.8-25 83.3-55.8 1.2-2.3 4-3.2 6.3-2.1 1.6.8 2.5 2.2 2.7 3.7z"
            fill="#5e3d25"
          ></path>
          <path
            d="m323.1 164.4c31.4-11.6 67.8-25 83.3-55.8.6-1.2 1.7-2 2.9-2.4 0-1.8-.1-2.9-.1-2.9-.2-1.5-1.1-2.9-2.5-3.7-2.3-1.2-5.1-.2-6.3 2.1-15.5 30.8-51.9 44.2-83.3 55.8l-2.8 1.1c-66.6 24.6-68.4 77.6-68.4 81.9-.1 1.6.6 3.2 2.1 4.2 1.3.8 2.8 1 4.1.5.7-11.1 7.5-57.3 68.3-79.8z"
            fill="#4d321e"
          ></path>
          <path
            d="m233.1 197.4c15.7-58.6 76.5-113.2 136.5-122.4 18.9-2.9 36.5-1.1 51 5.8-16.4-15.1-40.3-20.2-66.6-16.2-60 9.2-120.8 63.8-136.4 122.4-7.4 27.7-3.9 53.9 12.2 72.1.2.2.3.4.5.6 5.5 6 12 10.7 19.3 14.2-1.3-1.2-2.5-2.4-3.7-3.7-.2-.2-.4-.4-.5-.6-16.1-18.3-19.6-44.5-12.3-72.2z"
            fill="#5e3d25"
          ></path>
        </g>
        <g>
          <path
            d="m240.8 297.3c23.1 17 36.8 39.6 35.6 63.8v.8c-1.5 24.2-17.5 45.2-42.3 59.6-24.3 14.1-57.2 21.8-92.9 19.9-35.7-1.9-67.5-13.2-90.2-29.8-23.1-17-36.8-39.6-35.6-63.8 0-.3 0-.5 0-.8 1.5-24.2 17.5-45.2 42.3-59.6 24.3-14.1 57.2-21.8 92.9-19.9 35.7 2 67.6 13.2 90.2 29.8z"
            fill="#805333"
          ></path>
          <path
            d="m252.5 363.7c-.1.1-28.6 36.6-96.4 13.9-10.7-3.6-13.7-5.4-20.4-9.6-1.4-.9-3-1.8-4.6-2.8-6.6-4-17.3-9.1-31.9-12.2s-33.1-4.1-55.2.3c-2.5.5-5-1.1-5.5-3.7-.3-1.7.3-3.4 1.5-4.4 3.1-3 41.8-39.2 106.3-9.6l2.8 1.3c30.4 14 65.6 30.2 98.4 19.4 2.5-.8 5.1.5 5.9 3 .4 1.6 0 3.2-.9 4.4z"
            fill="#5e3d25"
          ></path>
          <path
            d="m148.4 346.1c30.4 14 65.6 30.2 98.4 19.4 1.3-.4 2.6-.3 3.7.3 1.3-1.3 1.9-2.1 2-2.1 1-1.2 1.3-2.8.8-4.4-.8-2.5-3.5-3.8-5.9-3-32.8 10.8-68-5.4-98.4-19.4l-2.8-1.3c-64.4-29.6-103.2 6.6-106.3 9.6-1.2 1.1-1.8 2.7-1.5 4.4.3 1.5 1.3 2.7 2.5 3.3 8.4-7.3 45.8-35.2 104.7-8.1z"
            fill="#4d321e"
          ></path>
          <path
            d="m61.4 305.8c52.5-30.4 134.1-26 183 9.9 15.4 11.3 26.6 25.1 32 40.2-.9-22.3-14.2-42.8-35.6-58.6-48.9-35.9-130.6-40.3-183-9.9-24.8 14.4-40.8 35.4-42.3 59.6v.8c-.4 8.1.9 16 3.6 23.6-.1-1.8-.1-3.5 0-5.3 0-.3 0-.5 0-.8 1.5-24.2 17.5-45.1 42.3-59.5z"
            fill="#5e3d25"
          ></path>
        </g>
      </g>
    </svg>
  ),
  smoothie: (props) => (
    <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m17.329 14c-.25-.19-.51-.4-.75-.62-3.11-2.79-3.52-7.041-3.58-8.131-.01-.14.12-.26.28-.25 1.06.05 4.9.34 7.91 2.37l2.811 7.631h-5z"
        fill="#91af33"
      />
      <path
        d="m26.689 14c.78-1.16 1.28-2.89 1.31-4.83.07-3.96-2.51-7.271-3.2-8.091-.09-.1-.24-.11-.34 0-.72.79-3.39 4.01-3.46 7.971-.03 1.99.44 3.77 1.21 4.95l.791 1h3z"
        fill="#a4ce3d"
      />
      <path
        d="m34.5 14 1.56-8.13c.55-2.83 3.02-4.87 5.9-4.87h6.04c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-6.12c-.96 0-1.78.68-1.96 1.62l-1.42 7.38-.5 1h-3z"
        fill="#bf1b4a"
      />
      <path
        d="m46.15 25-3.83 31.36c-.18 1.51-1.46 2.64-2.98 2.64h-18.68c-1.52 0-2.8-1.13-2.98-2.64l-3.83-31.36 1.15-1h30z"
        fill="#a4ce3d"
      />
      <path d="m47 18-.85 7h-32.3l-.85-7v-1h34z" fill="#d8e3e5" />
      <rect fill="#e7f1f2" height="4" rx="2" width="38" x="11" y="14" />
      <path d="m36.38 25 1.35-7h-4l-1.35 7z" fill="#bf1b4a" />
      <path
        d="m37 41.19c0 5.075-3.134 6.81-7 6.81s-7-1.735-7-6.81 3.134-9.19 7-9.19 7 4.114 7 9.19z"
        fill="#91af33"
      />
      <path
        d="m33.707 40.293c-.391-.391-1.023-.391-1.414 0l-1.293 1.293v-3.586c0-.553-.447-1-1-1s-1 .447-1 1v3.586l-1.293-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.707 2.707v8.586c0 .553.447 1 1 1s1-.447 1-1v-8.586l2.707-2.707c.391-.391.391-1.023 0-1.414z"
        fill="#75822a"
      />
    </svg>
  ),
  'orange-juice': (props) => (
    <svg
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      {...props}
    >
      <g>
        <path
          d="m405.68 180.66v-59.139c0-4.377-3.548-7.925-7.925-7.925h-179.636c-4.377 0-7.925 3.548-7.925 7.925v59.139z"
          fill="#dbedff"
        ></path>
        <path
          d="m262.899 113.596h-44.78c-4.377 0-7.925 3.548-7.925 7.925v59.139h46.195v-56.129c-.001-4.702 2.639-8.815 6.51-10.935z"
          fill="#b5dcff"
        ></path>
        <path
          d="m445.522 7.425c-4.065-7.081-13.101-9.524-20.178-5.46l-60.874 34.945c-10.794 6.197-17.5 17.778-17.5 30.225v113.508h29.562v-113.508c0-1.889 1.017-3.646 2.655-4.586l60.874-34.946c7.08-4.064 9.525-13.098 5.461-20.178z"
          fill="#b5dcff"
        ></path>
        <g>
          <path
            d="m375.039 30.843-10.569 6.067c-10.794 6.197-17.5 17.778-17.5 30.225v113.508h15.195v-122.779c0-10.551 4.831-20.467 12.874-27.021z"
            fill="#8bcaff"
          ></path>
        </g>
        <path
          d="m220.764 476.78 1.53 29.785c4.756 3.416 10.584 5.435 16.887 5.435h137.513c16.009 0 28.987-12.978 28.987-28.987v-6.233z"
          fill="#ff9b00"
        ></path>
        <path
          d="m220.764 476.78 1.53 29.785c4.756 3.416 10.584 5.435 16.887 5.435h23.718c-3.87-2.119-6.511-6.233-6.511-10.935v-24.285z"
          fill="#fc8900"
        ></path>
        <path
          d="m210.193 178.583v92.36c55.74 11.133 97.744 60.332 97.744 119.346 0 34.906-14.699 66.375-38.238 88.569h135.981v-300.275z"
          fill="#ffb640"
        ></path>
        <path d="m405.68 178.583h-195.487v92.359l10.677 207.916h184.81z" fill="#ffb640"></path>
        <path d="m210.193 178.583v92.359l10.677 207.916h35.518v-300.275z" fill="#ff9b00"></path>
        <circle cx="186.225" cy="390.289" fill="#ffd086" r="121.711"></circle>
        <path
          d="m131.475 390.288c0-55.607 37.292-102.503 88.231-117.046-10.637-3.037-21.869-4.665-33.481-4.665-67.219 0-121.712 54.492-121.712 121.711 0 67.22 54.492 121.712 121.712 121.712 11.612 0 22.844-1.628 33.481-4.665-50.938-14.543-88.231-61.439-88.231-117.047z"
          fill="#ffc365"
        ></path>
        <circle cx="186.225" cy="390.289" fill="#ffc365" r="93.485"></circle>
        <path
          d="m174.402 297.545c-46.048 5.812-81.662 45.118-81.662 92.744s35.614 86.932 81.662 92.744c-26.255-22.325-42.927-55.58-42.927-92.744s16.672-70.42 42.927-92.744z"
          fill="#ffb640"
        ></path>
        <path
          d="m186.226 289.077c-55.783 0-101.212 45.402-101.212 101.212 0 55.743 45.356 101.211 101.212 101.211 55.743 0 101.211-45.355 101.211-101.211 0-55.746-45.358-101.212-101.211-101.212zm-85.04 90.232c1.981-15.438 8.076-29.604 17.157-41.357 1.066-1.38 3.101-1.518 4.335-.285l41.026 41.026c1.428 1.428.417 3.869-1.603 3.869h-58.051c-1.737 0-3.085-1.529-2.864-3.253zm17.157 63.316c-9.081-11.753-15.176-25.919-17.157-41.357-.221-1.724 1.127-3.253 2.865-3.253h58.051c2.019 0 3.03 2.441 1.603 3.869l-41.026 41.026c-1.234 1.233-3.269 1.095-4.336-.285zm60.156 29.838c0 1.738-1.529 3.086-3.253 2.865-15.438-1.981-29.604-8.076-41.357-17.157-1.38-1.066-1.518-3.101-.285-4.335l41.026-41.026c1.428-1.428 3.869-.417 3.869 1.602zm0-106.298c0 2.019-2.441 3.03-3.869 1.602l-41.026-41.026c-1.233-1.233-1.095-3.268.285-4.335 11.753-9.082 25.919-15.176 41.357-17.158 1.724-.221 3.253 1.127 3.253 2.865zm75.609-28.212c9.081 11.753 15.176 25.919 17.157 41.357.221 1.724-1.127 3.253-2.865 3.253h-58.05c-2.019 0-3.03-2.441-1.603-3.869l41.026-41.026c1.233-1.234 3.269-1.095 4.335.285zm-60.156-29.839c0-1.738 1.529-3.086 3.253-2.865 15.438 1.981 29.603 8.076 41.357 17.157 1.38 1.066 1.518 3.101.285 4.335l-41.026 41.026c-1.428 1.428-3.869.417-3.869-1.603zm44.609 150.057c-11.753 9.081-25.918 15.176-41.356 17.157-1.724.221-3.253-1.127-3.253-2.865v-58.05c0-2.019 2.441-3.03 3.869-1.602l41.026 41.025c1.233 1.233 1.095 3.268-.286 4.335zm32.704-56.903c-1.981 15.438-8.076 29.603-17.157 41.356-1.066 1.38-3.101 1.518-4.335.285l-41.026-41.026c-1.428-1.428-.417-3.869 1.603-3.869h58.05c1.738.001 3.086 1.53 2.865 3.254z"
          fill="#ffb640"
        ></path>
        <path
          d="m85.014 390.289c0 55.531 45.012 100.859 100.575 101.203-7.885-5.277-15.113-11.45-21.55-18.375-11.092-2.971-21.304-8.112-30.149-14.947-1.38-1.066-1.518-3.101-.285-4.335l10.171-10.171c-2.445-5.003-4.537-10.207-6.287-15.566l-14.81 14.81c-1.233 1.233-3.268 1.095-4.335-.285-9.081-11.753-15.176-25.919-17.157-41.357-.221-1.724 1.127-3.253 2.865-3.253h27.692c-.16-2.557-.268-5.129-.268-7.727s.108-5.169.268-7.726h-27.692c-1.738 0-3.086-1.529-2.865-3.253 1.981-15.438 8.076-29.604 17.157-41.357 1.066-1.38 3.101-1.518 4.335-.285l14.81 14.81c1.75-5.359 3.842-10.563 6.287-15.566l-10.171-10.171c-1.233-1.233-1.095-3.268.285-4.335 8.845-6.835 19.058-11.976 30.15-14.947 6.437-6.924 13.665-13.098 21.55-18.375-55.492.348-100.576 45.61-100.576 101.208z"
          fill="#ff9b00"
        ></path>
      </g>
    </svg>
  ),
  soda2: (props) => (
    <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m44 25a19.5677 19.5677 0 0 0 -6.8333-14.8571l-.1667-.1429h-10l-.1667.1429a19.5677 19.5677 0 0 0 -6.8333 14.8571 37.9247 37.9247 0 0 0 1.0933 9.1851 25.9089 25.9089 0 0 1 0 12.63 37.925 37.925 0 0 0 -1.0933 9.1849v.008a6 6 0 0 0 6 5.992h12a6 6 0 0 0 6-5.992v-.008a37.925 37.925 0 0 0 -1.0933-9.1852 25.9089 25.9089 0 0 1 0-12.63 37.9247 37.9247 0 0 0 1.0933-9.1848z"
        fill="#f7b622"
      ></path>
      <path
        d="m42.9067 34.1851a37.9247 37.9247 0 0 0 1.0933-9.1851 19.568 19.568 0 0 0 -6.8333-14.8571l-.1667-.1429h-4l.1667.1429a19.568 19.568 0 0 1 6.8333 14.8571 37.9247 37.9247 0 0 1 -1.0933 9.1851 25.9089 25.9089 0 0 0 0 12.63 37.925 37.925 0 0 1 1.0933 9.1849v.0081a6 6 0 0 1 -6 5.9919h4a6 6 0 0 0 6-5.9919v-.0081a37.925 37.925 0 0 0 -1.0933-9.1852 25.9089 25.9089 0 0 1 0-12.6297z"
        fill="#f6ad06"
      ></path>
      <path d="m27 8h10v2h-10z" fill="#f7b622"></path>
      <path
        d="m21.0933 34.1851a37.9247 37.9247 0 0 1 -1.0933-9.1851 19.568 19.568 0 0 1 6.8333-14.8571l.1667-.1429h4l-.1667.1429a19.568 19.568 0 0 0 -6.8333 14.8571 37.9247 37.9247 0 0 0 1.0933 9.1851 25.9089 25.9089 0 0 1 0 12.63 37.925 37.925 0 0 0 -1.0933 9.1849v.0081a6 6 0 0 0 6 5.9919h-4a6 6 0 0 1 -6-5.9919v-.0081a37.925 37.925 0 0 1 1.0933-9.1852 25.9089 25.9089 0 0 0 0-12.6297z"
        fill="#f8c03f"
      ></path>
      <rect fill="#fad277" height="1" rx=".5" width="11" x="26.5" y="9"></rect>
      <path
        d="m27 2h10a1 1 0 0 1 1 1v5a0 0 0 0 1 0 0h-12a0 0 0 0 1 0 0v-5a1 1 0 0 1 1-1z"
        fill="#0fd70c"
      ></path>
      <g fill="#5ae34f">
        <path d="m36 2h1a1 1 0 0 1 1 1v5a0 0 0 0 1 0 0h-2a0 0 0 0 1 0 0v-6a0 0 0 0 1 0 0z"></path>
        <path d="m32 2h2v6h-2z"></path>
        <path d="m28 2h2v6h-2z"></path>
      </g>
      <path
        d="m43.8762 28h-23.7524a36.7483 36.7483 0 0 0 .97 6.1851 25.9122 25.9122 0 0 1 .7348 7.8149h20.3428a25.9122 25.9122 0 0 1 .7353-7.8149 36.7483 36.7483 0 0 0 .9695-6.1851z"
        fill="#f7992c"
      ></path>
      <path
        d="m43.8762 28h-4a36.7483 36.7483 0 0 1 -.9695 6.1851 25.9122 25.9122 0 0 0 -.7353 7.8149h4a25.9122 25.9122 0 0 1 .7353-7.8149 36.7483 36.7483 0 0 0 .9695-6.1851z"
        fill="#f68706"
      ></path>
      <path
        d="m20.1238 28h4a36.7483 36.7483 0 0 0 .97 6.1851 25.9122 25.9122 0 0 1 .7348 7.8149h-4a25.9122 25.9122 0 0 0 -.7353-7.8149 36.7483 36.7483 0 0 1 -.9695-6.1851z"
        fill="#f9ac53"
      ></path>
    </svg>
  ),
  soda3: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m339.519 285.278c2.453-5.348 3.717-11.099 3.717-16.909v-102.801c0-31.132-19.019-58.147-46.883-71.634-7.282-3.525-11.967-10.834-11.967-18.924v-38.413h-56.776v38.413c0 8.09-4.685 15.4-11.967 18.924-27.864 13.487-46.883 40.502-46.883 71.634v102.801c0 5.81 1.264 11.561 3.717 16.909l1.775 3.871c5.326 11.614 5.281 24.874-.719 36.203-3.14 5.929-4.773 12.445-4.773 19.048v103.255 32.172c0 17.768 15.555 32.171 34.743 32.171 8.388 0 16.077-2.756 22.078-7.341 2.445-1.868 5.894-1.868 8.339 0 6.002 4.585 13.69 7.341 22.078 7.341 8.388 0 16.077-2.757 22.078-7.341 2.445-1.868 5.894-1.868 8.339 0 6.002 4.585 13.69 7.341 22.078 7.341 19.188 0 34.742-14.404 34.742-32.171v-134.761c0-6.746-1.471-13.465-4.673-19.525-5.954-11.269-6.331-24.375-1.036-35.92z"
          fill="#f3f0f3"
        ></path>
        <path
          d="m337.528 289.617c-5.291 11.549-4.92 24.652 1.04 35.923 3.201 6.062 4.673 12.784 4.673 19.526v134.766c0 8.883-3.891 16.922-10.18 22.748-6.289 5.815-14.976 9.418-24.569 9.418-3.592 0-7.051-.504-10.303-1.451 5.435-1.565 10.303-4.333 14.235-7.967 6.279-5.826 10.169-13.865 10.169-22.748v-134.767c0-6.742-1.472-13.463-4.673-19.526-5.949-11.271-6.33-24.374-1.029-35.923l1.987-4.344c2.45-5.342 3.716-11.096 3.716-16.901v-102.805c0-13.247-3.75-26.18-11.457-37.01-7.544-10.602-18.135-18.652-29.464-24.851-5.722-3.131-10.867-6.67-14.409-12.218-3.197-5.008-3.514-10.669-3.514-16.478v-32.114h20.637v32.114c0 8.09 4.683 15.398 11.971 18.929 27.863 13.484 46.884 40.503 46.884 71.629v102.806c0 5.805-1.266 11.559-3.726 16.901z"
          fill="#e2dee2"
        ></path>
        <path
          d="m337.528 289.62c-5.296 11.545-4.918 24.65 1.033 35.917 3.199 6.061 4.67 12.787 4.67 19.533v134.759c0 8.882-3.885 16.92-10.174 22.742-6.279 5.822-14.963 9.429-24.56 9.429-8.396 0-16.076-2.762-22.087-7.342-2.444-1.868-5.892-1.868-8.336 0-3 2.285-6.418 4.123-10.144 5.385-3.726 1.272-7.74 1.957-11.933 1.957-8.386 0-16.076-2.762-22.077-7.342-2.444-1.868-5.892-1.868-8.336 0-6.011 4.58-13.691 7.342-22.087 7.342-19.185 0-34.734-14.406-34.734-32.171v-135.425c0-6.607 1.629-13.125 4.769-19.056 6.001-11.326 6.041-24.59.715-36.195l-1.768-3.875c-2.454-5.345-3.716-11.098-3.716-16.91v-102.802c0-20.785 8.475-39.732 22.404-54.049h129.658c13.93 14.317 22.405 33.264 22.405 54.049v102.802c0 5.812-1.262 11.565-3.716 16.91z"
          fill="#685e68"
        ></path>
        <path
          d="m337.528 289.617c-5.526 12.084-5.137 24.244 1.029 35.922 3.201 6.062 4.673 12.784 4.673 19.526v134.766c0 4.992-1.225 9.727-3.417 13.937-1.47 2.817-3.361 5.409-5.599 7.678-.717.727-1.549 1.505-2.357 2.193-6.165 5.187-14.359 8.358-23.365 8.358-2.7 0-5.427-.282-8.059-.875-.731-.165-1.441-.35-2.151-.556-.031 0-.062-.01-.093-.021 5.435-1.565 10.303-4.333 14.235-7.967 6.279-5.826 10.169-13.865 10.169-22.748v-134.765c0-6.742-1.472-13.463-4.673-19.526-5.949-11.271-6.33-24.374-1.029-35.923l1.987-4.344c2.45-5.342 3.716-11.096 3.716-16.901v-102.805c0-13.247-3.747-26.185-11.456-37.014-4.704-6.618-10.602-12.238-17.117-17.035h26.803c.082.082.154.165.227.247 4.896 5.6 9.418 11.021 12.99 17.662 2.576 4.79 4.824 10.271 6.31 15.471 1.92 6.72 2.882 13.674 2.882 20.668v102.806c0 4.714-.834 9.397-2.46 13.854-.924 2.527-2.127 4.947-3.245 7.392z"
          fill="#554e56"
        ></path>
        <path
          d="m298.315 37.395c0 3.036-2.658 5.498-5.937 5.498h-36.381-36.381c-3.279 0-5.937-2.461-5.937-5.498v-31.897c0-3.036 2.658-5.498 5.937-5.498h72.761c3.279 0 5.937 2.461 5.937 5.498v31.897z"
          fill="#e94444"
        ></path>
        <path
          d="m298.312 5.5v31.898c0 3.036-2.656 5.496-5.929 5.496h-20.586c3.273 0 5.929-2.46 5.929-5.496v-31.898c0-3.036-2.656-5.496-5.929-5.496h20.586c3.273 0 5.929 2.46 5.929 5.496z"
          fill="#d83131"
        ></path>
        <path d="m168.759 167.895h174.477v101.577h-174.477z" fill="#e94444"></path>
        <path d="m322.65 167.895h20.586v101.577h-20.586z" fill="#d83131"></path>
      </g>
    </svg>
  ),
  juice1: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" {...props}>
      <path
        d="m46.374 202.386c-92.355-114.027 66.343-252.373 166.708-145.486z"
        fill="#fdb62f"
      ></path>
      <path
        d="m213.117 56.913-166.712 145.456c-36.364-44.881-33.846-93.613-11.183-129.533-10.508 42.03 43.8 77.029 79.986 45.4l84.578-73.764a147.823 147.823 0 0 1 13.331 12.441z"
        fill="#ed9c02"
      ></path>
      <path
        d="m321.394 180.6c-71.291-14.086-173.212 20.225-240.55 6.591 1.481-6.3 3.11-12.59 4.739-18.96l.074-.073v-.074l65.841-57.4h149.307c8.073 23.475 14.96 46.878 20.589 69.916z"
        fill="#e5e5e5"
      ></path>
      <path
        d="m321.394 180.6c-71.321-14.072-173.229 20.218-240.55 6.591 1.481-6.3 3.11-12.59 4.739-18.96l.074-.073v-.074l14.146-12.3c0 .074 0 .074-.074.148a15.235 15.235 0 0 0 13.627 18.886c22.441 1.926 47.621.074 73.691-2.74 42.422-4.555 90.251-12.294 129.9-8.962 1.558 5.851 3.04 11.702 4.447 17.484z"
        fill="#d6d6d6"
      ></path>
      <path
        d="m223.967 306.906a7.374 7.374 0 0 1 -5.7-2.683c-9.027-10.954-22.016-17.055-39.707-18.649a7.411 7.411 0 0 1 -6.712-8.043c2.141-15.406 36.681.151 42.9 4.177.586-6.143 1.446-38.128 15.52-33.35a7.4 7.4 0 0 1 4.1 9.638 67.839 67.839 0 0 0 -3.258 39.511 7.462 7.462 0 0 1 -7.143 9.399z"
        fill="#8c421c"
      ></path>
      <path
        d="m192.75 74.614-126.05 110.054c-32.1-35.768-25.663-93.868 12.81-121.904 34.544-26.31 84.69-21.179 113.24 11.85z"
        fill="#ffde76"
      ></path>
      <path
        d="m143.055 47.063c-1.205 16.888-4.221 59.267-5.332 75.616a2.722 2.722 0 0 1 -.371.3c-.815.667-1.777 1.556-2.814 2.519-.074.074-.148.147-.222.147-4.131 3.692-10.738 9.381-13.554 11.776l-74.5-4.814h-.148a77.518 77.518 0 0 1 1.111-16.59c12.446.768 42.173 2.781 61.767 4-14.516-16-34.809-38.364-41.771-45.992a77.066 77.066 0 0 1 12.289-11.261l42.512 46.88 4.443-63.618a82.584 82.584 0 0 1 16.59 1.037z"
        fill="#fdb62f"
      ></path>
      <path
        d="m192.75 74.614-126.05 110.054c-27.8-31.066-19.256-68.693-19.256-69.543 12.38 15.48 44.748 23.231 67.766 3.11l64.211-55.99a80.83 80.83 0 0 1 13.329 12.369z"
        fill="#ffd757"
      ></path>
      <path
        d="m139.5 97.054-1.777 25.625a2.722 2.722 0 0 1 -.371.3c-.444.445-1.481 1.333-2.814 2.519-.074.074-.148.147-.222.147-4.131 3.692-10.738 9.381-13.554 11.776l-74.5-4.814h-.148a77.518 77.518 0 0 1 1.111-16.59c.592.075-.009-.047 1.028.027 17.034 15.7 46.149 20.34 66.96 2.195z"
        fill="#ed9c02"
      ></path>
      <path
        d="m341.761 301.314-60.212 191.67h-162.712c-88.133-.444-55.4-219-37.993-305.8 69.469 13.553 167.97-20.663 240.55-6.591a762.775 762.775 0 0 1 20.367 120.721z"
        fill="#fdb62f"
      ></path>
      <path
        d="m384.346 52.1a12.172 12.172 0 0 1 -15.257 10.665c-8.186-2.208-63.9-17.172-70.58-19.034a11.823 11.823 0 0 0 -2.74-.445c-8.958-.519-12.1 9.409-15.923 15.628l-.3.444c-16.765 29.374-53.231 93.1-70.284 122.867q-15.079 1.791-30.068 3.629c19.106-33.426 58.356-102.128 77.248-135.237h.074c1.814-3.233 5.5-9.739 7.332-12.96h.075l.148-.3a36.482 36.482 0 0 1 37.7-17.849c9.548 2.189 62.477 16.766 73.024 19.478 5.848 1.633 10.217 7.114 9.551 13.114z"
        fill="#fd7b2f"
      ></path>
      <path
        d="m217.116 168.6c-2.962 5.036-5.555 9.628-7.851 13.627-10.072 1.185-20.07 2.37-30.068 3.629 2.37-4.073 5.036-8.739 7.85-13.775 9.924-1.04 19.997-2.299 30.069-3.481z"
        fill="#fd6811"
      ></path>
      <path
        d="m316.061 23.215-6.072 23.477c0 .075 0 .075-.074.149l-14.146-3.556h-.148c-.074-.074 0-.222 0-.3l6.147-23.477c4.132.77 10.169 2.692 14.293 3.707z"
        fill="#fdca6a"
      ></path>
      <path
        d="m263.848 37.657h.075l22 8.3a8.486 8.486 0 0 1 1.407.74l-7.48 12.221-.3.444-22-8.221a4.549 4.549 0 0 1 -1.037-.518h-.074z"
        fill="#fdca6a"
      ></path>
      <path
        d="m386.2 377.227c-5.607-73.163-90.806-118.275-154.343-82.282a6.631 6.631 0 0 0 -.592.371c-120.173 71.248-24.794 246.39 100.056 185.078z"
        fill="#fd9133"
      ></path>
      <path
        d="m339.983 283.465c-99.417-56.514-214.315 45.735-168.336 151.512 7.348 16.9-4.754 35.789-23.186 35.789-74.801-.366-65.321-174.192-43.547-280.766a167.152 167.152 0 0 1 -24.07-2.814c-17.288 86.384-50.1 305.393 37.993 305.8h162.712l60.212-191.67c-.445-5.853-1.037-11.777-1.778-17.851z"
        fill="#fdab11"
      ></path>
      <path
        d="m386.2 377.227-54.882 103.167c-117.759 61.778-224.01-110.834-100.056-185.079a6.825 6.825 0 0 1 .592-.37c63.951-36.587 149.353 10.662 154.346 82.282z"
        fill="#fd9133"
      ></path>
      <g fill="#fdb62f">
        <path d="m263.478 322.644a7.794 7.794 0 0 1 -5.258-2.148 7.588 7.588 0 0 1 0-10.516c7-6.583 17.235 3.493 10.516 10.516a7.8 7.8 0 0 1 -5.258 2.148z"></path>
        <path d="m293.1 322.644a7.79 7.79 0 0 1 -5.258-2.148c-6.7-7.017 3.447-17.088 10.516-10.516a7.591 7.591 0 0 1 0 10.516 7.8 7.8 0 0 1 -5.258 2.148z"></path>
        <path d="m278.29 344.862a7.794 7.794 0 0 1 -5.258-2.148c-6.737-7.032 3.563-17.092 10.517-10.515a7.589 7.589 0 0 1 0 10.515 7.8 7.8 0 0 1 -5.259 2.148z"></path>
      </g>
      <path
        d="m223.981 299.511c-35.414-31.2-25.489-60.359 5.652-88.568 28.544 34.785 36.945 66.086-5.652 88.568z"
        fill="#77a226"
      ></path>
      <path
        d="m245.407 282.948a36.049 36.049 0 0 0 6.444-11.851c-27.054 6.764-48.5-21.257-34.738-44.345a85 85 0 0 1 10.668-14.089c-26.2 24.493-36.059 49.684-14.039 76.336l-.033.021a100.384 100.384 0 0 0 10.291 10.517c12.017-6.345 16.081-11.267 21.4-16.59z"
        fill="#658920"
      ></path>
      <path
        d="m382.494 357.305-33.831 45.635c-66.876 87.3-198.725-11.914-130.584-98.663-103.049 78.923.781 235.355 113.239 176.117l54.882-103.167a92.8 92.8 0 0 0 -3.706-19.922z"
        fill="#fd8115"
      ></path>
      <path
        d="m448.324 293.476c114.56 91.693-10.961 260.717-131.824 177.706z"
        fill="#fdb62f"
      ></path>
      <path
        d="m466.776 311.165c-10.515 14.146-67.346 90.793-79.1 106.647-20.576 27.288-1.536 68.859 34.071 68.288-30.81 12.294-68.284 10.516-105.241-14.886 9.447-12.737 126.8-171 131.829-177.747a135.963 135.963 0 0 1 18.441 17.698z"
        fill="#ed9c02"
      ></path>
      <path
        d="m453.889 426.107-.222.37a72.331 72.331 0 0 1 -8.667 11.48c-28.355 32.382-77.776 37.616-112.5 11.7l43.7-58.878 1.778-2.518 8.887-11.85 1.778-2.518 43.695-58.878c34.926 25.754 44.156 74.528 21.551 111.092z"
        fill="#ffde76"
      ></path>
      <path
        d="m470.585 377.878-2.333-15.093-78.991 11.434-1.866 2.592c-2.323 3.038-7.006 9.159-9.329 12.2l-1.866 2.589 11.662 77.448a87.267 87.267 0 0 0 15.394-2.287c-.849-5.634-7.008-46.726-10.036-66.769 18.646 13.546 46.991 34.189 55.208 40.165l9.1-11.815.233-.381c-7.932-5.767-36.651-26.65-55.346-40.239 20.461-2.977 62.758-9.058 68.17-9.844z"
        fill="#fdb62f"
      ></path>
      <path
        d="m450.334 333.309-26.588 35.919h-.074c-7.026 9.585-18.478 24.9-25.477 34.365l-3.7 4.962-6.813 9.257a43.286 43.286 0 0 0 -2.148 48.214 82.78 82.78 0 0 1 -53.034-16.368c27.679-37.329 72.151-97.369 99.834-134.642a80.992 80.992 0 0 1 18 18.293z"
        fill="#ffd757"
      ></path>
      <path
        d="m410.934 386.485c-3.111.444-6 .888-8.517 1.259q2.333 1.666 4.888 3.554l-9.11 12.3c-1.7-1.259-3.407-2.444-4.962-3.629.371 2.592.815 5.48 1.259 8.591-9.268 12.593-9.114 11.777-12.739 20.218l-4.887-38.956 12.22-16.515 34.586-4.074h.074z"
        fill="#ed9c02"
      ></path>
    </svg>
  ),
};
